import EntityChangelogApiService from '../services/api/entityChangelogs';
import { enqueueNotification } from './notifications';

const ENTITY_CHANGELOGS_SHOW_MODAL = 'ENTITY_CHANGELOGS_SHOW_MODAL';
const ENTITY_CHANGELOGS_CLOSE_MODAL = 'ENTITY_CHANGELOGS_CLOSE_MODAL';

const ENTITY_CHANGELOGS_FETCH_LIST_REQUEST = 'ENTITY_CHANGELOGS_FETCH_LIST_REQUEST';
const ENTITY_CHANGELOGS_FETCH_LIST_SUCCESS = 'ENTITY_CHANGELOGS_FETCH_LIST_SUCCESS';
const ENTITY_CHANGELOGS_FETCH_LIST_FAILED = 'ENTITY_CHANGELOGS_FETCH_LIST_FAILED';

const initialState = {
  entityName: null,
  entityLabel: null,
  entityId: null,
  params: {
    perPage: 5,
    page: 1
  },
  fetching: false,
  fetched: false,
  items: [],
  total: 0
};

export default function entityChangelogs(state = initialState, action) {
  switch (action.type) {
    case ENTITY_CHANGELOGS_SHOW_MODAL:
      return {
        ...state,
        ...initialState,
        entityName: action.payload.entityName,
        entityLabel: action.payload.entityLabel,
        entityId: action.payload.entityId
      };
    case ENTITY_CHANGELOGS_CLOSE_MODAL:
      return {
        ...initialState
      };
    case ENTITY_CHANGELOGS_FETCH_LIST_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        entityName: action.payload.entityName,
        entityId: action.payload.entityId,
        params: action.payload.parameters,
        total: 0
      };
    case ENTITY_CHANGELOGS_FETCH_LIST_SUCCESS:
      if (
        action.payload.entityName !== state.entityName ||
        action.payload.entityId !== state.entityId
      ) {
        return state;
      }

      return {
        ...state,
        fetched: true,
        fetching: false,
        items: action.payload.items,
        total: action.payload.total
      };
    case ENTITY_CHANGELOGS_FETCH_LIST_FAILED:
      if (
        action.payload.entityName !== state.entityName ||
        action.payload.entityId !== state.entityId
      ) {
        return state;
      }
      return { ...state, fetching: false };
    default:
      return state;
  }
}

export function fetchEntityChangelogs({ entityName, entityId, ...params }) {
  return dispatch => {
    dispatch({
      type: ENTITY_CHANGELOGS_FETCH_LIST_REQUEST,
      payload: { entityName, entityId, parameters: params }
    });

    const api = new EntityChangelogApiService();

    return api
      .fetch({ entityName, entityId, ...params })
      .then(response =>
        dispatch({
          type: ENTITY_CHANGELOGS_FETCH_LIST_SUCCESS,
          payload: { entityName, entityId, items: response.data, total: response.meta.total }
        })
      )
      .catch(error => {
        dispatch({ type: ENTITY_CHANGELOGS_FETCH_LIST_FAILED, payload: { entityName, entityId } });
        dispatch(enqueueNotification('error', error.message));
      });
  };
}

export const showEntityChangelogs = (id, label, entityName) => ({
  type: ENTITY_CHANGELOGS_SHOW_MODAL,
  payload: { entityId: id, entityLabel: label, entityName }
});

export const closeEntityChangelogs = () => ({ type: ENTITY_CHANGELOGS_CLOSE_MODAL });
